import { queryOptions } from '@tanstack/react-query';

import type { InstrumentFinancialsPageData } from './get-instrument-financials-page-data.ts';
import { getInstrumentFinancialsPageData } from './get-instrument-financials-page-data.ts';

export interface InstrumentFinancialsPageDataQueryInput {
	readonly ticker?: string;
}

export function getInstrumentFinancialsPageDataQueryOptions({ ticker }: InstrumentFinancialsPageDataQueryInput) {
	return queryOptions<InstrumentFinancialsPageData>({
		queryFn: () =>
			getInstrumentFinancialsPageData({
				data: {
					ticker,
				},
			}),
		queryKey: ['instrument-financials-page-data', ticker ?? null],
		staleTime: 60_000,
	});
}
